import { container } from '@debatdirect/common/src/modules/container';

/**
 * Connection handler.
 */
const ConnectionHandler = {
  /**
   * Initialize.
   */
  init: function (structure) {
    this._offlineHandler = this._handleOffline.bind(this);
    this._onlineHandler = this._handleOnline.bind(this);

    this._offlineTasksHandler = this._performOfflineTasks.bind(this);
    this._onlineTasksHandler = this._performOnlineTasks.bind(this);

    this._offlineTimer = null;

    this._setListeners(true);
  },

  /**
   * Dispose.
   */
  dispose: function () {
    this._setListeners(false);
    this._clearOfflineTimer();
  },

  /**
   * Add or remove listeners.
   * @param {Boolean} activate
   * @private
   */
  _setListeners: function (activate) {
    const method = activate ? 'addEventListener' : 'removeEventListener';

    window[method]('offline', this._offlineHandler, false);
    window[method]('online', this._onlineHandler, false);
  },

  /**
   * Handle offline event.
   * @private
   */
  _handleOffline: function () {
    this._clearOfflineTimer();

    // Prevent displaying the NoConnection prompt if connection is restored almost immediately
    this._offlineTimer = setTimeout(this._offlineTasksHandler, 2000);
  },

  /**
   * Handle online event.
   * @private
   */
  _handleOnline: function () {
    this._clearOfflineTimer();

    // Needs a timeout because Android triggers the online handler too soon.
    setTimeout(this._onlineTasksHandler, 250);
  },

  /**
   * Perform offline tasks.
   * @private
   */
  _performOfflineTasks: function () {
    this._clearOfflineTimer();
    this._setPrompt(true);
  },

  /**
   * Perform online tasks.
   * @private
   */
  _performOnlineTasks: function () {
    // Hide prompt.
    this._setPrompt(false);
  },

  /**
   * Show or hide no connection prompt.
   * @param {Boolean} activate
   * @private
   */
  _setPrompt: function (activate) {
    if (activate) {
      container.get('prompt').prompt({
        identifier: 'NoConnection',
        backdrop: true,
      });
    } else {
      container.get('prompt').dismiss('dismiss', 'NoConnection');
    }
  },

  /**
   * Clear offline timer.
   * @private
   */
  _clearOfflineTimer: function () {
    clearTimeout(this._offlineTimer);
    this._offlineTimer = null;
  },
};

/**
 * Public exports
 */
export default ConnectionHandler;
